module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-breadcrumbs', {
    attrs: {
      "items": [{
          text: 'Dashboard',
          to: {
            path: '/'
          }
        },
        {
          text: 'Ambis Test',
          to: {
            path: '/ambis-test'
          },
        },
        {
          text: 'List Bundle Subtes'
        } ],
      "divider": "|"
    }
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-title', [_c('div', {
    staticClass: "font-size-16 font-weight-600"
  }, [_vm._v("\n                Daftar Bundle Subtes\n            ")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "depressed": "",
      "color": "blew",
      "dark": ""
    },
    on: {
      "click": function($event) {
        return _vm.$router.push('/ambis-test/create-bundle')
      }
    }
  }, [_c('v-icon', [_vm._v("mdi-plus")]), _vm._v(" Tambah Bundle\n            ")], 1)], 1), _vm._v(" "), _c('v-card-text', [_c('v-text-field', {
    staticClass: "mb-4",
    attrs: {
      "append-icon": "mdi-magnify",
      "placeholder": "Masukan kata kunci pencarian",
      "dense": "",
      "outlined": "",
      "hide-details": ""
    },
    model: {
      value: (_vm.search),
      callback: function($$v) {
        _vm.search = $$v
      },
      expression: "search"
    }
  }), _vm._v(" "), _c('v-data-table', {
    attrs: {
      "item-key": "bundle_code",
      "headers": _vm.headers,
      "items": _vm.bundles,
      "search": _vm.search,
      "loading": _vm.loading,
      "no-data-text": "Data bundle subtes tidak tersedia"
    },
    scopedSlots: _vm._u([{
      key: "item.actions",
      fn: function(ref) {
        var item = ref.item;

        return [_c('v-btn', {
          staticClass: "red--text",
          attrs: {
            "small": "",
            "depressed": "",
            "color": "lightred"
          },
          on: {
            "click": function($event) {
              return _vm.confirmDeleteItem(item)
            }
          }
        }, [_vm._v("\n                        Hapus\n                    ")]), _vm._v(" "), _c('v-btn', {
          staticClass: "blew--text",
          attrs: {
            "small": "",
            "depressed": "",
            "color": "lightblue"
          },
          on: {
            "click": function($event) {
              return _vm.editBundle(item)
            }
          }
        }, [_vm._v("\n                        Edit\n                    ")])]
      }
    }, {
      key: "no-results",
      fn: function() {
        return [_c('div', {
          staticClass: "text-center"
        }, [_c('p', {
          staticClass: "my-2"
        }, [_vm._v("Hasil pencarian tidak ditemukan.")])])]
      },
      proxy: true
    }]),
    model: {
      value: (_vm.datatable),
      callback: function($$v) {
        _vm.datatable = $$v
      },
      expression: "datatable"
    }
  })], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "persistent": "",
      "max-width": "450"
    },
    model: {
      value: (_vm.confirmDialog),
      callback: function($$v) {
        _vm.confirmDialog = $$v
      },
      expression: "confirmDialog"
    }
  }, [_c('dialog-confirm', {
    attrs: {
      "title": 'Hapus Bundle Subtes',
      "subtitle": 'Apakah anda akan menghapus Bundle Subtes ini ?'
    },
    on: {
      "close": function($event) {
        _vm.confirmDialog = false
      },
      "confirm": function($event) {
        return _vm.deleteBundle()
      }
    }
  })], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "d-flex"
  }, [_c('h3', {
    staticClass: "header-text font-weight-bold"
  }, [_vm._v("Bundle Subtes")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4a66924d","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/modules/ambis_test/components/ListBundle.vue
// module id = 1511
// module chunks = 1